<template>
  <div class="prohibited-content-text">
    <h1>{{ t("Prohibited Content Categories") }}</h1>

    <p>{{ t("Prohibited content includes, but is not limited to, the following:") }}</p>

    <table>
      <thead>
        <tr>
          <th>{{ t("Prohibited Content Category") }}</th>
          <th>{{ t("Description") }}</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>{{ t("Child Sexual Abuse Material (CSAM)") }}</td>
          <td>
            {{
              t(
                'Content should not feature, imply, or suggest the involvement of individuals under 18 years of age. The term "teen" must be accompanied by clear statements that models are 18 or 19 years old e.g. Teen 18 +. This also applies to tags and category names. Individuals under the age of 18 may not be involved in any content of a sexual nature, regardless of whether they are participating.',
              )
            }}
          </td>
        </tr>
        <tr>
          <td>{{ t("Rape / Non - Consensual Sexual Activity") }}</td>
          <td>
            {{
              t(
                "This includes any content which is real or implies a lack of consent. Examples include but are not limited to assault, rape, force, asleep, drugged, passed / blacked out, kidnap, capture, chloroformed, unconscious, hypnotized, drunk, intoxicated, inebriated, stoned, etc. Someone who is under the influence of drugs or alcohol, sleeping, hypnotized, etc., cannot give consent. Therefore, any sexual activity with such an individual (including suggested) is considered non - consensual and is classified as a violation.",
              )
            }}
          </td>
        </tr>
        <tr>
          <td>{{ t("Alcohol, Drugs, & Drug Paraphernalia") }}</td>
          <td>
            {{
              t(
                "Alcohol, drugs and drug paraphernalia are not allowed, regardless of whether they are being consumed / used or they are in the background. There must be no reference or inference to alcohol, drugs or drug paraphernalia in the title, description, or comments. Someone who is under the influence of alcohol or drugs cannot give consent. Possession and use of certain drugs is also illegal.",
              )
            }}
          </td>
        </tr>
        <tr>
          <td>{{ t("Bestiality") }}</td>
          <td>
            {{
              t(
                "This includes content showing, describing, or implying sexual activity with animals (including cartoon characters) and non - human creatures (aliens, mythological creatures, fantasy characters, etc.).",
              )
            }}
          </td>
        </tr>
        <tr>
          <td>{{ t("Incest") }}</td>
          <td>
            {{
              t(
                "Content suggesting sexual activity between biological family members or close relatives is banned. It is considered illegal in many jurisdictions, and there is always the concern that incest may involve one party being under the age of 18. This does not extend to step - relatives, stipulating that all parties are depicted as over 18. Use of words such as daddy, mommy, uncle, etc.are prohibited by many of our acquiring partners.",
              )
            }}
          </td>
        </tr>
        <tr>
          <td>{{ t("Violence & Extreme Sexual Violence") }}</td>
          <td>
            {{
              t(
                "Any content depicting violence and extreme sexual violence is prohibited. This includes mutilation of a person or body part, depiction of blood, broken skin, excessive bruising, brutality, and / or pain.",
              )
            }}
          </td>
        </tr>
        <tr>
          <td>{{ t("Weapons") }}</td>
          <td>
            {{
              t(
                "There can be no weapons visible on the website. There must be no reference or inference to weapons in the title, description, or comments. Knifes, swords, blades, guns, including replicas etc are prohibited.",
              )
            }}
          </td>
        </tr>
        <tr>
          <td>{{ t("Intellectual Property Rights Violations") }}</td>
          <td>
            {{
              t(
                "Any sale of goods or services involving the unauthorized use of a material for which you do not hold rights is prohibited. This includes counterfeit goods, content not properly licensed, and the unauthorized use of a celebrity's name, image, or likeness.",
              )
            }}
          </td>
        </tr>
        <tr>
          <td>{{ t("Obscenity") }}</td>
          <td>
            {{
              t(
                "Any sale of patently offensive goods or services that violate contemporary community standards. This includes depictions of scat or human feces.",
              )
            }}
          </td>
        </tr>
        <tr>
          <td>{{ t("Hate Crimes") }}</td>
          <td>
            {{
              t(
                "Content promoting hostility, prejudice or crime motivated by age, colour, disability, ethnicity, gender, gender identity, nationality, race, religion or sexual orientation.",
              )
            }}
          </td>
        </tr>
        <tr>
          <td>{{ t("Death & Necrophilia") }}</td>
          <td>{{ t("Any content depicting death, dead people, autopsies, executions, snuff, fantasy snuff, necrophilia or suicide.") }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";

defineOptions({
  name: "prohibited-content-text",
});
const { t } = useI18n();
</script>

<style lang="scss">
@import "./index";
</style>
